export enum FlowTypes {
  CELLPHONE = 'CELLPHONE',
  EMAIL = 'EMAIL',
  EMAIL_AND_PHONE = 'EMAIL_AND_PHONE',
}
